export default "__VITE_ASSET__CwMhEkXb__"